import { z } from 'zod';
import {
  CaseIdSchema,
  EventIdSchema,
  IsoTimestampSchema,
  SourceIdSchema,
  SourceItemIdSchema,
} from './common.js';
import { EventParticipantSchema } from './participant.js';

/**
 * Hendelsestyper – tilsvarer §9.7 i prosjektplanen.
 * Unified Event Model: alle kilder normaliseres til denne listen.
 */
export const EventTypeSchema = z.enum([
  'email',
  'sms',
  'imessage',
  'whatsapp',
  'document',
  'attachment',
  'meeting',
  'note',
  'system_import',
]);
export type EventType = z.infer<typeof EventTypeSchema>;

/**
 * Kjernemodellen i CaseTrace.
 * Alle hendelser – uavhengig av kilde – normaliseres til dette skjemaet.
 * Tungt arbeid (parsing, OCR, hashing) skjer ved import, ikke ved søk.
 */
export const EventSchema = z.object({
  id: EventIdSchema,
  caseId: CaseIdSchema,
  timestamp: IsoTimestampSchema,
  type: EventTypeSchema,
  /** Kilden hendelsen ble importert fra */
  source: SourceIdSchema,
  title: z.string().min(1, 'Tittel kan ikke være tom'),
  /** Kort tekstutdrag for forhåndsvisning i tidslinje */
  contentPreview: z.string().max(500, 'Forhåndsvisning kan ikke overstige 500 tegn').optional(),
  /** Referanse til fullt innhold i objektlagring */
  contentFullRef: z.string().optional(),
  /** Friform metadata, f.eks. e-postheadere, meldingsid, tråd-id */
  metadata: z.record(z.string(), z.unknown()),
  participants: z.array(EventParticipantSchema).optional(),
  sourceItemId: SourceItemIdSchema,
});

export type Event = z.infer<typeof EventSchema>;
